import * as THREE from 'three';
import { sharedScene } from './sharedScene.js';
import { DEFAULT_RENDER_TUNING, RenderTuning } from './renderTuning.js';
import { DEFAULT_GRAPHICS_QUALITY, getTVRenderSizeForDevice, GraphicsQuality } from './quality.js';
import { HOST_CAMERA_POLICY } from './hostCameraPolicy.js';
import { WorldViewportView } from './WorldViewportView.js';

export class HostCockpitView extends WorldViewportView {
  constructor(
    container: HTMLElement,
    quality: GraphicsQuality = DEFAULT_GRAPHICS_QUALITY,
    tuning: RenderTuning = DEFAULT_RENDER_TUNING,
    scene: THREE.Scene = sharedScene
  ) {
    super(container, quality, tuning, HOST_CAMERA_POLICY, scene, {
      framingAspectRatio: WorldViewportView.TV_VIEWPORT_ASPECT_RATIO,
      fixedRenderSize: getTVRenderSizeForDevice(quality),
      showHullModel: true
    });
  }
}
